export enum FieldPresetType {
  Mobile = 'mobile',
  Info = 'full',
  Full = 'info-full',
  MediaOnly = 'media',
  ReferenceComparison = 'reference-comparison',
  MobileReferenceComparison = 'mobile-reference-comparison',
  Solutions = 'solutions',
  SolutionsMedia = 'solutions-media',
  CollectionCombo = 'collection-combo',
}

export const FIELD_PRESET_TYPE_MOBILE_COMPARISON = FieldPresetType.Mobile;
export const FIELD_PRESET_TYPE_FULL = FieldPresetType.Full;
export const FIELD_PRESET_TYPE_MEDIA_ONLY = FieldPresetType.MediaOnly;
export const FIELD_PRESET_TYPE_REFERENCE_COMPARISON = FieldPresetType.ReferenceComparison;
export const FIELD_PRESET_TYPE_MOBILE_REFERENCE_COMPARISON = FieldPresetType.MobileReferenceComparison;
export const FIELD_PRESET_TYPE_SOLUTIONS = FieldPresetType.Solutions;
export const FIELD_PRESET_TYPE_SOLUTIONS_MEDIA_ONLY = FieldPresetType.SolutionsMedia;
